import React, { useEffect } from 'react';
import Home from './home';
import { Helmet } from 'react-helmet';

const Contactanos = () => {
  useEffect(() => {
    const footer = document.getElementById('contacto');
    if (footer) {
      setTimeout(() => {
        footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Contáctanos | CES</title>
        <meta name="description" content="Ponte en contacto con CES." />
      </Helmet>
      <Home showHero={false} />
    </>
  );
};

export default Contactanos;
